import { mergeAttributes, Node } from "@tiptap/core";

export interface YouTubeOptions {
  HTMLAttributes: Record<string, unknown>;
  controls: boolean;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    youtube: {
      /**
       * Add a YouTube video
       */
      setYouTube: (options: { videoId: string }) => ReturnType;
    };
  }
}

export const YouTube = Node.create<YouTubeOptions>({
  name: "youtube",

  addOptions() {
    return {
      HTMLAttributes: {},
      controls: true,
    };
  },

  group: "block",

  atom: true,

  addAttributes() {
    return {
      videoId: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'iframe[src*="youtube.com"]',
      },
      {
        tag: 'iframe[src*="youtu.be"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const videoId = HTMLAttributes.videoId;
    return [
      "div",
      { class: "relative w-full bg-black rounded-lg overflow-hidden" },
      [
        "div",
        { class: "relative" },
        [
          "div",
          { style: "padding-bottom: 56.25%; position: relative; height: 0;" },
          [
            "iframe",
            mergeAttributes(
              {
                src: `https://www.youtube.com/embed/${videoId}`,
                width: "100%",
                height: "100%",
                style: "position: absolute; top: 0; left: 0; width: 100%; height: 100%;",
                frameborder: "0",
                allow:
                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: true,
              },
              this.options.HTMLAttributes
            ),
          ],
        ],
      ],
    ];
  },

  addCommands() {
    return {
      setYouTube:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },
});
